var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proposition-content-input"},[_c('label',{staticClass:"form-label",attrs:{"for":"motionContent"}},[_vm._v(" What is to be voted upon")]),_vm._v(" "),_c('wysiwyg',{attrs:{"id":"motionContent","name":"motion-content"},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }